module.exports = __webpack_public_path__ + "static/media/piotech.061ca627.png";